<template>
  <div class="contract_page">
    <header class="contract_header"><span class="back" @click="$router.back()">‹</span><b>{{ $t('contract.title') }}</b></header>
    <main class="contract_paper" v-if="contract">
      <h1>{{ contract.title }}</h1>
      <p class="contract_no">{{ $t('contract.contractNo') }}：{{ contract.contract_no }}</p>
      <article class="contract_html" v-html="contract.rendered_html"></article>
      <section class="signatures">
        <div class="signature">
          <h3>{{ contract.party_a.role_name || $t('contract.partyA') }}</h3>
          <p>{{ contract.party_a.name }}</p>
          <strong>{{ $t('contract.realNameConfirm') }}</strong>
          <p class="signed_date">{{ signedDate }}</p>
        </div>
        <div class="signature seal">
          <h3>{{ contract.party_b.role_name || $t('contract.partyB') }}</h3>
          <p>{{ contract.party_b.company_name }}</p>
          <p class="signed_date">{{ signedDate }}</p>
          <img v-if="contract.seal_b_snapshot" :src="contract.seal_b_snapshot" alt="乙方公章">
        </div>
        <div class="signature seal">
          <h3>{{ contract.party_c.role_name || $t('contract.partyC') }}</h3>
          <p>{{ contract.party_c.company_name }}</p>
          <p class="signed_date">{{ signedDate }}</p>
          <img v-if="contract.seal_c_snapshot" :src="contract.seal_c_snapshot" alt="丙方公章">
        </div>
      </section>
      <footer><p class="hash">{{ $t('contract.hash') }}：{{ contract.hash }}</p></footer>
    </main>
  </div>
</template>
<script>
import Fetch from '../../utils/fetch';
export default {
  name: 'investContract',
  data() { return { contract: null }; },
  computed: {
    signedDate() {
      if (!this.contract || !this.contract.signed_at) return '';
      const match = String(this.contract.signed_at).match(/^(\d{4})-(\d{2})-(\d{2})/);
      return match ? `${match[1]}年${match[2]}月${match[3]}日` : String(this.contract.signed_at);
    }
  },
  created() { this.$parent.footer('user', false); this.load(); },
  methods: { load() { Fetch('/user/contract_detail', { id: this.$route.params.id }).then(r => { this.contract = r.data; }); } }
};
</script>
<style lang="less" scoped>
.contract_page { min-height: 100vh; background: #eef3fb; padding-top: 52px; color: #222; }
.contract_header { position: fixed; z-index: 20; top: 0; left: 0; right: 0; height: 52px; line-height: 52px; text-align: center; color: #fff; background: #3775f4; font-size: 17px; }
.back { position: absolute; left: 4px; top: 0; display: flex; align-items: center; justify-content: center; width: 44px; height: 52px; box-sizing: border-box; color: #fff; background: transparent !important; border: 0 !important; box-shadow: none !important; font-size: 34px; font-weight: 300; line-height: 1; }
.contract_paper { width: calc(100% - 24px); box-sizing: border-box; margin: 12px; padding: 22px 14px; background: #fff; box-shadow: 0 2px 12px rgba(20,60,120,.1); }
h1 { text-align: center; font-size: 22px; margin: 5px 0 12px; }
.contract_no { text-align: left; color: #666; font-size: 12px; word-break: break-all; }
.contract_html { font-size: 14px; line-height: 1.9; overflow-wrap: anywhere; word-break: break-word;
  /deep/ .invest-contract > p:first-child { display: none; }
  /deep/ img { max-width: 100%; height: auto; }
  /deep/ table { width: 100% !important; max-width: 100%; border-collapse: collapse !important; table-layout: fixed; }
  /deep/ td, /deep/ th { box-sizing: border-box; padding: 8px !important; border: 1px solid #555 !important; word-break: break-word; overflow-wrap: anywhere; }
}
.signatures { display: flex; width: 100%; border-top: 1px solid #ddd; margin-top: 24px; padding-top: 16px; }
.signature { position: relative; box-sizing: border-box; flex: 0 0 33.333%; width: 33.333%; min-height: 142px; padding: 0 5px 25px; overflow: visible; }
.signature h3 { position: relative; z-index: 2; font-size: 12px; line-height: 1.35; margin: 0 0 7px; word-break: break-word; }
.signature p { position: relative; z-index: 2; margin: 0; font-size: 11px; line-height: 1.45; word-break: break-word; }
.signature strong { position: relative; z-index: 2; color: #3775f4; font-size: 10px; line-height: 1.35; }
.signed_date { position: absolute !important; left: 5px; right: 5px; bottom: 0; white-space: nowrap; font-size: 9px !important; }
.seal img { position: absolute; z-index: 1; right: 2px; bottom: 20px; width: 72px; height: 72px; object-fit: contain; opacity: .88; pointer-events: none; }
footer { border-top: 1px dashed #ccc; margin-top: 12px; padding-top: 12px; color: #666; font-size: 12px; line-height: 1.6; }
.hash { overflow-wrap: anywhere; }
</style>
